import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Redirect, generatePath } from 'react-router-dom';

import { URLS } from 'config';
import { selectors } from 'store';

const ApplyRedirect: React.FunctionComponent = function () {
  const { id, path } = useSelector(selectors.getPathKey);

  const props = useMemo(
    () => ({
      pathname: generatePath(URLS.applyForFinance, { id }),
      state: { referrer: path },
    }),
    [id, path],
  );
  return <Redirect to={props} />;
};

export default ApplyRedirect;
